/*
 * Apply to all form.view.form
 */

$(function () {
    var lotOfPages = false;
    $('form.view.form').each(function () {
        let index = 1;
        new adapt.form(this);
        const count = $(this).find('.form_page').length;
        if (count >= 3) {
            lotOfPages = true;
        }

        $(this).find('.form_page').each(function () {
            $(this).attr('name', index);
            index++;
        });

    });

    var currentApplication = window.location.search.substring(1);
    if (lotOfPages) {
        url = window.location.search.substring(1);
        var historyObject = {type: "HistoryStateOfForm"};
        if (url.indexOf("page=") > -1) {
        } else {
            History.replaceState(historyObject, document.title, "?" + currentApplication + "&page=1");
        }
    }

    /*
     * I removed this because it is crashing out the javascript
     * engine. urlPage does not exist
     *
     * Matt
     **/
    $(window).on('popstate', function () {
        if (typeof urlPage === 'undefined') {
        } else {
            const text = window.location.search.substring(1);

            const sliceStarter = urlPage.indexOf("page=");

            const page = text.slice(sliceStarter + 5, text.length);

            $('.form_page').each(function () {
                $(this).hide();
            });
            $("div[name='" + page + "']").show();

            $('form.view.form').each(function () {
                const counter = $(this).find('.form_page').length;
                if (counter === 1) {
                    $(this).find('.form_page').show();
                }
            });
        }
    });

    $('select[name="ats_rigth_to_work_company_id"]').on(
        'change',
        function () {
            $(this).parents('form').trigger('submit');
        }
    );

    $('select[name="ats_rigth_to_work_role_id"]').on(
        'change',
        function () {
            $(this).parents('form').trigger('submit');
        }
    );
});


adapt.form = function (form) {
    this.version = '1.0.1';
    this.form = form;

    /*
     * Initialise form, hide all the pages except the first
     */

    /* Should we display the whole form in an accordion? */
    if ($(form).hasClass('full')) {
        if (!$(form).hasClass('complete')) {
            $(form).find('.view.form_page_section:not(.ats_di_container)').wrapInner('<div class="inner"></div>');
            $(form).find('.view.form_page').each(function (index) {
                var $this = $(this);
                var $titles = $this.find('h1,h2,h3,h4,h5,h6');
                var page = index + 1;
                var title = "" + page;
                if ($titles.length) {
                    const mainTitle = $($titles.get(0));
                    title = mainTitle.text();
                    mainTitle.hide();

                }
                $this.prepend('<div class="page-toggle closed">' + title + '</div>');
            });

            $(form).find('.view.form_page').show();
            $(form).find('.view.form_page').first().find('.page-toggle').removeClass('closed').addClass('open');
        }

        $(form).addClass('complete');
    } else {
        $(form).find('.view.form_page').hide();
        $(form).find('.view.form_page').first().show();
    }

    /*
     * Initialise dependent fields
     */
    this.update_dependencies();

    /*
     * Attach focus events to inputs
     */
    $(form).find('input[type!="file"],textarea').on(
        'focus',
        null,
        {
            self: this
        },
        function (event) {
            //alert(event.data.self);
            event.data.self.focus_input($(this));
        }
    );

    $(form).find('input[type="file"]').on(
        'focus',
        null,
        {
            self: this
        },
        function () {
            var $this = $(this);
            $this.parents('.form_page_section_field').removeClass('has-error');
            $this.parents('.form-group').removeClass('has-error');
        }
    );


    $(form).find('input[type="checkbox"]').on(
        'change',
        null,
        {
            self: this
        },
        function (event) {
            event.data.self.focus_input($(this));
        }
    );
    /*
     * Attach blur events to the inputs
     */
    $(form).find('input[type!="file"],textarea').on(
        'blur',
        null,
        {
            self: this
        },
        function (event) {
            event.data.self.blur_input($(this));
            event.data.self.update_dependencies();
        }
    );

    /*
     * Attach focus events to selects
     */
    $(form).find('select').on(
        'focus',
        null,
        {
            self: this
        },
        function (event) {
            event.data.self.focus_select($(this));
        }
    );

    /*
     * Attach blur events to the selects
     */
    $(form).find('select,input[type="radio"]').on(
        'change',
        null,
        {
            self: this
        },
        function (event) {
            //If this has data-context
            event.data.self.update_dependencies();
        }
    )

    /*
     * Remove the previous button from the
     * first page if it exists
     */
    $(form).find('.view.form_page').first().find('.control.previous').detach();

    /*
     * Attach events to the form previous controls
     */
    $(form).find('.view.form_page .control.previous').on(
        'click',
        null,
        {
            self: this
        },
        function (event) {
            const $this = $(this);

            /* Hide this page */
            $this.parents('.view.form_page').hide();


            /*History*/
            const State = History.getState();
            if (State.data["type"] == "HistoryStateOfForm") {
                History.back();
            }


            /* Show the previous page */
            $this.parents('.view.form_page').prev().show();
            $('html, body').animate({scrollTop: $(".view.page_tabs").offset().top}, 'slow');

            var href = window.location.pathname + window.location.search;
            var matches = href.match(/[0-9]+$/);
            href = href.replace(/[0-9]+$/, matches[0] - 1);

            ga('send', 'pageView', href);
        }
    );

    /*
     * Attach events to the next controls
     */
    $(form).on('click', '.view.form_page .control.next', {
            self: this
        },
        function (event) {
            const $this = $(this);
            if (event.data.self.is_page_valid($this.parents('.view.form_page'))) {

                if ($this.parents('.person_contact_sheet_form').length > 0) {
                    return false; // prevent submit on profile form    
                }

                /* Hide the current page */
                $this.parents('.view.form_page').hide();

                /* Is there another page? */
                if ($this.parents('.view.form_page').next().length > 0) {
                    /* We have another page so lets display it */
                    var s = $this.parents('.view.form_page').next().get(0).outerHTML;
                    if (s.indexOf("view_form_submission") > -1) {
                        $this.parents('.view.form_page').next().show();
                        $(form).find('.view.form_page .control.partial-save').hide();
                        event.data.self.form.submit();
                    } else {
                        $this.parents('.view.form_page').next().show();

                        const State = History.getState();
                        if (State.data["type"] == "HistoryStateOfForm") {
                            const urlPage = window.location.search.substring(1);
                            const sliceStart = urlPage.indexOf("page=");
                            const slice = urlPage.slice(0, parseInt(sliceStart, 10));

                            var historyObject = {type: "HistoryStateOfForm"};
                            let state = '';
                            if ($this.parents('.view.form_page').next().css('display') == 'block') {
                                state = $this.parents('.view.form_page').next().attr("name");
                            }
                            History.pushState(historyObject, document.title, "?" + slice + "page=" + state);
                        }
                    }
                } else {
                    /* Lets submit the form */
                    const $form = $(event.data.self.form);
                    $form.append('<div style="text-align: center"><i class="fa fa-gear fa-spin fa-5x"></i></div>');
                    $(form).find('.view.form_page .control.partial-save').hide();
                    $(event.data.self.form).trigger('submit');
                }
            }
        }
    );

    /*
     * Attach events to the parital save button
     */
    $(form).find('.view.form_page .control.partial-save').on(
        'click',
        function () {
            var $form = $(this).parents('form');
            $form.find('input[name="actions"]').val($form.find('input[name="partial_save_actions"]').val());
            $form.trigger('submit');
        }
    );

    /*
     * Deal with clonable sections
     */
    $(form).find('.view.form_page_section.clonable')


    $(form).find('.view.form_page_section.clonable .control.clone').on(
        'click',
        null,
        {
            self: this
        },
        function () {
            var $this = $(this);
            var $first = $this.parents('.view.form_page_section.clonable');
            var $clone = $first.clone(true, true);

            /* Reset any inputs */
            $clone.find('input[type="text"]').val("");

            $first.before($clone);
        }
    );

    $(form).find('.view.form_page_section.clonable .control.delete-clone').on(
        'click',
        null,
        {
            self: this
        },
        function () {
            var $this = $(this);

            if ($(form).find('.view.form_page_section.clonable .control.delete-clone').length > 1) {
                $this.parents('.view.form_page_section.clonable').detach();
            }
        }
    );


}

adapt.form.prototype.update_dependencies = function ($context) {
    /* Find all fields that have dependencies */
    $('[data-adapt-depends-on]').each(function () {
        var target = $(this).attr('data-adapt-depends-on');
        var value = $(this).attr('data-adapt-depends-on-value');

        var $target = adapt.find_closest($(this), "[name='" + target + "']");

        if ($target.length) {
            if ($target.attr('type') == 'radio') {
                if ($target.val() == value && $target.checked) {
                    if ($(this).hasClass('form_page_section')) {
                        $(this).hide();
                    } else {
                        $(this).parents('.view.form_page_section_field').hide();
                    }
                } else {
                    if ($(this).hasClass('form_page_section')) {
                        $(this).show();
                    } else {
                        $(this).parents('.view.form_page_section_field').show();
                    }
                }
            } else {
                if ($target.val() != value) {
                    if ($(this).hasClass('form_page_section')) {
                        $(this).hide();
                    } else {
                        $(this).parents('.view.form_page_section_field').hide();
                    }
                } else {
                    if ($(this).hasClass('form_page_section')) {
                        $(this).show();
                    } else {
                        $(this).parents('.view.form_page_section_field').show();
                    }
                }
            }
        }
    });

    /* Update fields dependent on a function */
    $('[data-adapt-depends-on-function]').each(function () {
        var functions = $(this).attr('data-adapt-depends-on-function');
        functions = functions.split(/,/);

        var show = true;

        for (var i = 0; i < functions.length; i++) {
            var fn = window[functions[i]];

            if (typeof fn === "function") {
                if (!fn(this)) {
                    show = false;
                    break;
                }
            }
        }

        if (show) {
            if ($(this).hasClass('form_page_section')) {
                $(this).show();
                $(this).find(':input').removeAttr('disabled');
            } else {
                $(this).parents('.view.form_page_section_field').show();
                $(this).removeAttr('disabled');
            }
        } else {
            if ($(this).hasClass('form_page_section')) {
                $(this).hide();
                $(this).find(':input').attr('disabled', 'disabled');
            } else {
                $(this).parents('.view.form_page_section_field').hide();
                $(this).attr('disabled', 'disabled');
            }
        }
    });
}

adapt.form.prototype.focus_input = function ($input) {
    if ($input) {
        /* Remove any error classes */
        let mandatoryGroup = $input.attr('data-adapt-mandatory-group'),
            $page = $input.closest('.form_page'),
            $validateGroup = $input.closest('.form-group');

        var group_fields = $page.find('[data-adapt-mandatory-group="' + mandatoryGroup + '"]').get();
        for (var j = 0; j < group_fields.length; j++) {
            const $group_field = $(group_fields[j]);
            $group_field.parents('.has-error').removeClass('has-error');
        }

        if ($validateGroup.hasClass('has-error'))
            $validateGroup.removeClass('has-error');

        /* Strip the input if we have a validation class */
        adapt.sanitize.strip_input($input);

        /* Select all the text */
        $input.trigger('select');
    }
}

adapt.form.prototype.blur_input = function ($input) {
    if ($input) {
        /* Strip the input */
        adapt.sanitize.strip_input($input);

        if ($input.val() == "") {
            $input.parents('.has-error').removeClass('has-error');
        } else {
            /* Validate the input */
            var valid = adapt.sanitize.validate_input($input);

            /* Format the input if it is valid */
            if (valid) {
                adapt.sanitize.format_input($input);
            }
        }
    }
}

adapt.form.prototype.focus_select = function ($select) {
    if ($select) {
        $select.parents('.has-error').removeClass('has-error');
    }
}

adapt.form.prototype.is_page_valid = function ($page) {
    var valid = true;

    /* Check for mandatory fields */
    if ($page) {
        /* Get a list of mandatory fields */
        var mandatory_fields = $page.find('.form_page_section:visible [data-adapt-mandatory-group]:visible').get();

        for (var i = 0; i < mandatory_fields.length; i++) {
            var $field = $(mandatory_fields[i]);
            var group = $field.attr('data-adapt-mandatory-group');
            var atLeastOneFromGroupNotSelected = true;

            /* Get all the fields with the same group */
            var group_fields = $page.find('[data-adapt-mandatory-group="' + group + '"]').get();
            var group_error_count = 0;

            for (var j = 0; j < group_fields.length; j++) {
                const $group_field = $(group_fields[j]);
                var error_count = $group_field.parents('.has-error').length;
                if (error_count > 0) {
                    group_error_count++;
                }

                if (!$group_field.val() || $group_field.val() == "-1" ||
                    ($group_field.attr('type') == 'checkbox' && !$group_field.prop('checked')) ||
                    ($group_field.attr('type') == 'radio' && !$group_field.prop('checked'))) {
                    group_error_count++;
                } else {
                    atLeastOneFromGroupNotSelected = false;
                }
            }

            if (group_error_count > 0 && atLeastOneFromGroupNotSelected) {
                /* The group isn't valid so we need to mark all the fields in the group */
                for (var j = 0; j < group_fields.length; j++) {
                    const $group_field = $(group_fields[j]);
                    $group_field.parent().addClass('has-error');
                    $group_field.parent().parent().addClass('has-error');
                }
            }
        }

        if ($page.find('.has-error').length) {
            valid = false;
        }
    }

    return valid;
}
